require('./notyf.js');

(function(window){
  function UnnepekAruhazaForm(form) {
    try {
      if (!form || form.length == 0) {
        throw "Form is required";
      }

      this.form = form;
      var options = form.data('form-options');
      var texts = form.data('form-texts');
      var params = {};

      if (options) {
        params.options = this.parseOptions(options);
      }

      if (texts) {
        params.texts = this.parseOptions(texts);
      }

      if (params) {
        this.setParams(params);
      }

      this.init();
    } catch (error) {
      console.error(error);
    }
  }

  UnnepekAruhazaForm.prototype = {
    form: undefined,
    button: undefined,
    options: {
      ajax: true,
      buttonSelector: '[data-purpose="send-button]',
      errorClass: 'has-error'
    },
    texts: {},
    notyf: undefined,
    sendedForm: false,
    init: function() {
      this.setElements();
      this.addDOMEvents();
    },
    setElements: function() {
      this.button = this.form.find('[data-purpose="send-button"]');
      this.notyf = new Notyf({
        'delay': 4000
      });
    },
    addDOMEvents: function() {
      var _self = this;

      if (this.button) {
        this.button.click(function(e){
          e.preventDefault();
          _self.form.submit();
        });
      }

      this.form.submit(function(e){
        if (_self.isAjaxSend()) {
          e.preventDefault();
          _self.sendForm();
        }
      });
    },
    setParams: function(params) {
      if (params.texts) this.setTexts(params.texts);
      if (params.options) this.setOptions(params.options);
    },
    setAjax: function(ajax) {
      this.ajax = ajax;
    },
    sendForm: function() {
      if (!this.sendedForm) {
        var _self = this;
        var action = this.form.attr('action');
        this.sendedForm = true;
        this.button.attr('disabled', 'disabled');
        var errorClass = _self.getOption('errorClass');

        if (action) {
          $.ajax({
            url: this.form.attr('action'),
            dataType:'json',
            type:'post',
            data: this.form.serialize(),
            beforeSend: function() {
				$('#cover-spin').show();
				_self.form.find('.'+errorClass).removeClass(errorClass);
            },
            success: function(response) {
              if (response.ok) {
					if (response.message) {
						_self.notyf.confirm(response.message);
					}
					setTimeout(function(){
						_self.sendedForm = false;
						_self.button.removeAttr('disabled');
						$('#cover-spin').hide();
						if (response.modal) {
							$(response.modal).remodal().close();
						}
						if (response.redir) {
							window.location.href = response.redir;	
						}
						if (response.simple) {
							$('.simpleform').html(response.simple);
						}

					},500);
              } else {
                if (typeof response.errors === 'object') {
                  _self.showErrors(response.errors);
                }

                setTimeout(function(){
                  _self.sendedForm = false;
                  _self.button.removeAttr('disabled');
				  $('#cover-spin').hide();
                },500);
              }
            }
          });
        } else {
          this.form.find('.'+errorClass).removeClass(errorClass);
          var errors = {
            "required": "A csillaggal jelölt mezők kitöltése kötelező!",
            "email": "",
            "password": ""
          };

          this.showErrors(errors);

          setTimeout(function(){
            _self.sendedForm = false;
            _self.button.removeAttr('disabled');
          },500);
        }
      }
    },
    setOptions: function(options) {
      this.options = $.extend({}, this.options, options);
    },
    getOption: function(key) {
      return typeof this.options[key] !== 'undefined' ? this.options[key] : undefined;
    },
    setTexts: function(texts) {
      this.texts = $.extend({}, this.texts, texts);
    },
    getText: function(key) {
      return typeof this.texts[key] !== 'undefined' ? this.texts[key] : undefined;
    },
    isAjaxSend: function() {
      return this.getOption('ajax');
    },
    parseOptions(str) {
      var obj = {};
      var arr;
      var len;
      var val;
      var i;

      // Remove spaces before and after delimiters
      str = str.replace(/\s*:\s*/g, ':').replace(/\s*,\s*/g, ',');

      // Parse a string
      arr = str.split(',');
      for (i = 0, len = arr.length; i < len; i++) {
        arr[i] = arr[i].split(':');
        val = arr[i][1];

        // Convert a string value if it is like a boolean
        if (typeof val === 'string' || val instanceof String) {
          val = val === 'true' || (val === 'false' ? false : val);
        }

        // Convert a string value if it is like a number
        if (typeof val === 'string' || val instanceof String) {
          val = !isNaN(val) ? +val : val;
        }

        obj[arr[i][0]] = val;
      }

      return obj;
    },
    showErrors: function(errors) {
      if (typeof errors === 'object') {
        var _self = this;
        var errorClass = _self.getOption('errorClass');
        var top = 0;
        $.each(errors, function(key, text){
          var field = _self.form.find('[name="'+key+'"]');
          if (field.length > 0) {
            field.addClass(errorClass);
            if (top == 0 || top > field.offset().top) {
              top = field.offset().top;
            }
          }

          if (text.trim() !== '') {
            _self.notyf.alert(text);
          }
        });

        if (top > 0) {
          $('html, body').animate({scrollTop: top - 110}, 500);
        }
      }
    }
  };

  window.UnnepekAruhazaForm = UnnepekAruhazaForm;
})(window);
